import { useState } from 'react';

import { openInNewTab } from '~/components/rowPreview/RowPreviewPanel';
import type { CreatedFilter } from '~/components/tasks/CreatedDateFilter';
import { TaskDetailDialog, taskPath } from '~/components/tasks/detail/TaskDetailDialog';
import { TasksView } from '~/components/tasks/TasksView';

export function TasksTab({
  propertyId,
  propertyName,
  portfolioName,
}: {
  propertyId: string;
  propertyName: string;
  portfolioName: string | null;
}) {
  const [openTaskId, setOpenTaskId] = useState<string | null>(null);
  return (
    <>
      <TasksView
        scope={{ propertyId }}
        showProperty={false}
        onOpen={(task) => setOpenTaskId(task.id)}
        preview={{
          list: 'property_tasks',
          scope: 'table',
          onOpenFullPage: (taskId) => openInNewTab(taskPath(taskId)),
        }}
        newTaskContext={{ propertyId, propertyName, portfolioName }}
      />
      <TaskDetailDialog taskId={openTaskId} onClose={() => setOpenTaskId(null)} />
    </>
  );
}

export function CarTasksTab({
  carId,
  propertyId,
  propertyName,
  portfolioName,
  created,
  onCreatedChange,
}: {
  carId: string;
  propertyId: string;
  propertyName: string;
  portfolioName: string | null;
  created: CreatedFilter;
  onCreatedChange: (next: CreatedFilter) => void;
}) {
  const [openTaskId, setOpenTaskId] = useState<string | null>(null);
  return (
    <>
      <TasksView
        scope={{ carId }}
        showProperty={false}
        createdFilter="local"
        created={created}
        onCreatedChange={onCreatedChange}
        onOpen={(task) => setOpenTaskId(task.id)}
        preview={{
          list: 'elevator_tasks',
          scope: 'table',
          onOpenFullPage: (taskId) => openInNewTab(taskPath(taskId)),
        }}
        newTaskContext={{ propertyId, propertyName, portfolioName }}
      />
      <TaskDetailDialog taskId={openTaskId} onClose={() => setOpenTaskId(null)} />
    </>
  );
}
